import { Input } from "@/components/ui/input"

interface WeightRangeFilterProps {
  min: string
  max: string
  onMinChange: (val: string) => void
  onMaxChange: (val: string) => void
  text: { min: string; max: string }
}

export const WeightRangeFilter = ({
  min,
  max,
  onMinChange,
  onMaxChange,
  text,
}: WeightRangeFilterProps) => {
  return (
    <div className="flex items-center gap-4">
      <div className="group relative flex-1">
        <Input
          type="number"
          placeholder={text.min}
          value={min}
          onChange={(e) => onMinChange(e.target.value)}
          className="h-12 rounded-none border-0 bg-bone/80 pl-4 pr-12 text-sm font-semibold transition-all hover:bg-bone focus-visible:bg-bone focus-visible:ring-1 focus-visible:ring-accent/30 dark:bg-muted/30 dark:hover:bg-muted/50 dark:focus-visible:bg-muted/50"
        />
        <span className="absolute right-4 top-1/2 -translate-y-1/2 text-xs font-black uppercase tracking-widest text-muted-foreground/50 transition-colors group-focus-within:text-primary">
          KG
        </span>
      </div>

      <span className="text-muted-foreground/40">-</span>

      <div className="group relative flex-1">
        <Input
          type="number"
          placeholder={text.max}
          value={max}
          onChange={(e) => onMaxChange(e.target.value)}
          className="h-12 rounded-none border-0 bg-bone/80 pl-4 pr-12 text-sm font-semibold transition-all hover:bg-bone focus-visible:bg-bone focus-visible:ring-1 focus-visible:ring-accent/30 dark:bg-muted/30 dark:hover:bg-muted/50 dark:focus-visible:bg-muted/50"
        />
        <span className="absolute right-4 top-1/2 -translate-y-1/2 text-xs font-black uppercase tracking-widest text-muted-foreground/50 transition-colors group-focus-within:text-primary">
          KG
        </span>
      </div>
    </div>
  )
}

